define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var I18n = require('i18n!nls/main');
    var template = require('text!./index.tpl').default;
    var contactTpl = require('text!./item.tpl').default;
    var emptyTpl = require('text!./empty.tpl').default;
    var popover = require('behaviors/popover');
    var ContactCollection = require('collections/contacts');
    var ContactModel = require('models/contacts');
    var SmsEditPopover = require('popovers/sms_edit/view');
    var AppConfig = require('config/application');

    var EmptyView = Marionette.ItemView.extend({template: emptyTpl});

    var ItemContact = Marionette.ItemView.extend({
        template: contactTpl,
        className: 'caller__list scrollbar-macosx'
    });

    var Model = Backbone.Model.extend({
        search: true
    });

    return Marionette.LayoutView.extend({
        template: template,

        //regions: {
        //    regionList: '.js-region-list'
        //},

        ui: {
            'inputPhone': 'input[name=phone]',
            'inputName': '.js-call_input_name',
            'cleanInputSearch': '.js-caller-clean-search',
            'cleanInputCall': '.js-caller-clean-call',
            'openContact': '.js-caller-open-contact',
            'clickPhone': '.js-caller-phone',
            'call_btn_mobile': '.call_btn_mobile',
            'btnSendSms': '.btn_send_sms'
        },

        events: {
            'click @ui.cleanInputSearch': 'cleanInputSearch',
            'click @ui.cleanInputCall': 'cleanInputCall',
            'click @ui.openContact': 'slideContact',
            'click @ui.clickPhone': 'clickContactPhone',
            'click @ui.btnSendSms': 'sendSmsToPhone',
            'click @ui.call_btn_mobile': 'callMobile'
        },

        behaviors: {
            'popover': {behaviorClass: popover}
        },

        initialize: function() {
            this.$el.on('keydown', '.js-call_input_name', _.debounce(this.searchByName.bind(this), 500));
            //this.$el.on('keydown', '#js-call_to_phone', _.debounce(this.searchByPhone.bind(this), 500));

            this.model = new Model();
            app.Collections.contacts = new ContactCollection();
            this.listenTo(app.Collections.contacts, 'add', this.addedContact);
            this.contactsCollection = app.Collections.contacts;
            this.listenToOnce(this.contactsCollection, 'sync', function (data) {
                //this.afterRender();
                this.collectionToArray();
            });

            this.contactsCollection.fetch();
        },

        onRender: function () {
            $(this.ui.inputPhone).phoneinput();
        },

        callToPhone: function (options, checkRate = true, notCheckRate = false ) {
            var that = this;
            var input = $('#js-call_to_phone');
            /**
             * @type {string}
             */
            var phone = $(input).val();
            var id = $(input).data('contact_id');
            var call_type = options.type;

            var byContact = phone.indexOf('*') != -1 && id > 0;

            var method = byContact ? 'call' : 'call_to_number';
            var data = {
                call_type: call_type
            };

            if (byContact) {
                data.phone_id = id;
            } else {
                data.phone = phone;
            }

            data.check_rate = checkRate;
            data.not_check_rate = notCheckRate;

            Backbone.ajax({
                type: 'POST',
                url: AppConfig.host + '/rest/contacts/' + method,
                contentType: 'application/json',
                data: JSON.stringify(data),
                success: function (response) {
                    if(response.rate == -1) {
                        app.message.confirm(response.message,
                            function () {
                                window.location.hash = '#calls-scheme-settings?show=main'
                            },
                            function () {
                                that.callToPhone(options, false, $("input[name=notCheckRate]:visible").is(':checked'));
                            },
                            {
                                okText: 'Изменить номер',
                                cancelText: 'Позвонить'
                            }
                        );
                        return;
                    }
                    if (response.status == AppConfig.STATUS_OK) {
                        app.message.success(response.message);
                    } else {
                        app.message.error(response.message);
                    }
                },
                error: function (xhr) {
                    var response = $.parseJSON(xhr.responseText);
                    app.message.error(response.message || 'Ошибка');
                }
            })
        },

        searchByName: function() {
            var search = this.ui.inputName.val() || '';
            this.ui.inputPhone.val('');
            if (search.length) {
                this.searchContacts({query: search});
            } else {
                this.transform_collection(app.Collections.MissCalls);
            }
        },

        //searchByPhone: function() {
        //    var search = this.ui.inputPhone.val() || '';
        //    this.model.set('search', '');
        //    if (search.length) {
        //        this.searchContacts({phone: search});
        //    } else {
        //        this.transform_collection(app.Collections.MissCalls);
        //    }
        //},

        //searchContacts: function (data) {
        //    var self = this;
        //    data = data || {};
        //
        //    app.Collections.contacts.fetch({
        //        data: data,
        //        success: function () {
        //            if(self.isDestroyed) {
        //                return
        //            }
        //            self.contactsCollection = app.Collections.contacts;
        //            if (self.contactsCollection.length > 0) {
        //                self.collectionToArray();
        //            } else {
        //                //self.regionList.show(new EmptyView());
        //            }
        //        }
        //    });
        //},

        collectionToArray: function () {
            var that = this, first_letter, total, phones = [], item = {};

            _.each(this.contactsCollection.models, function (model, i) {
                first_letter = model.get('name').charAt(0).toUpperCase();
                phones = $.map(model.get('phones'), function (value, index) {
                    return [value];
                });

                total = model.get('total');

                if (typeof item[first_letter] == 'undefined') item[first_letter] = [];

                item[first_letter].push({
                    name: model.get('name'),
                    phones: phones,
                    id: model.id
                });
            });

            var overLength = false;
            if (this.contactsCollection.models.length < total) {
                overLength = true;
            }

            that.model.set({
                item: item,
                overLength: overLength
            });
            that.showContacts();
        },

        showContacts: function () {
            var that = this;
            //this.$el.lptSetter();
            //this.regionList.show(new ItemContact({model: this.model}));
            //this.$('.js-search').show();
            this.$el.lptSetter();

            //if (this.firstScrollInit) {
            //    setTimeout(function () {
            //        var styles = "overflow-x:hidden !important; max-height:" + $('.b-caller__contacts_block.js-scroller').outerHeight() + "px",
            //            $scroller = that.$('.js-scroller'),
            //            isFirefoxOnMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0 && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            //        if (isFirefoxOnMac) {
            //            app.States.isFirefoxOnMac = true;
            //            styles += 'overflow-y:scroll !important;';
            //        } else {
            //            app.States.isFirefoxOnMac = false;
            //        }
            //        $scroller.prop('style', styles);
            //        that.firstScrollInit = false;
            //    }, 1000);
            //}
        },

        cleanInputSearch: function (e) {
            if ($(e.currentTarget).prev().val() != '') {
                $(e.currentTarget).prev().val('');
                var self = this;
            }
            this.transform_collection(app.Collections.MissCalls);
        },

        cleanInputCall: function (e) {
            this.ui.inputPhone.val('');
            this.transform_collection(app.Collections.MissCalls);
        },

        slideContact: function (e) {
            var current = $(e.currentTarget);
            if (current.hasClass('b-caller__letter_passive')) {
                current.removeClass('b-caller__letter_passive').addClass('b-caller__letter_active');
                current.next('div').slideDown(400);
            }
            else {
                current.removeClass('b-caller__letter_active').addClass('b-caller__letter_passive');
                current.next('div').slideUp(400);
            }
        },

        clickContactPhone: function (e) {
            var number = $(e.currentTarget).text();
            var id = $(e.currentTarget).data('id');
            this.$('.b-caller__input').val(number);
            this.$('.b-caller__input').data('contact_id', id);
        },

        callMobile: function (event) {
            this.callToPhone({type: 'mobile'});
        },

        sendSmsToPhone: function(event) {
            var that = this;
            var target = event.target;
            var input = $('#js-call_to_phone');
            event.stopPropagation();
            this.triggerMethod('showPopover', {
                view: SmsEditPopover,
                target: target,
                data: {
                    options: {
                        placement: 'bottom-left'
                    }
                },
                handler: function(popover) {
                    that.listenToOnce(popover, 'sms:edited', function(message) {
                        var data = {
                            to: input.val(),
                            text: message
                        };
                        if(data.to.length) {
                            var msg = app.message.success('Отправка Sms', false);
                            that._xhr = Backbone.ajax({
                                url: AppConfig.host + '/rest/contacts/sms',
                                contentType: 'application/json',
                                type: 'POST',
                                data: JSON.stringify(data),
                                success: function (data) {
                                    msg.hide();
                                },
                                error: function (xhr) {
                                    var data = xhr.responseJSON;
                                    app.message.error(data.message);
                                }
                            });
                        } else {
                            app.message.error('Нет выбранных номеров');
                        }
                    })
                }
            });
        }
    })
});
